import { FormikProps } from 'formik';
import React from 'react';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { FieldAutomationIds } from '../../../../../global/constants/field-automation-ids';
import { NewHireProps } from '../../../models/arc-epi-props';
import { EmploymentType } from '../models/new-hire-form-model';

interface Props {
    newHireProps: NewHireProps;
    formProps: FormikProps<any>;
}
export function NewHireEmploymentType(props: Props) {
    const { newHireProps, formProps } = props;

     const employmentTypeOptions = [
		{
			 label: newHireProps?.layLabelText,
			 value: EmploymentType.Lay,
		},
		{
			label: newHireProps?.clergyLabelText,
			value: EmploymentType.Clergy,
		},
	];

    return (
		<FormField
			name='employment_type'
			label={newHireProps.nonStipEmploymentTypeLabel}
			component="radioGroup"
			options={employmentTypeOptions}
			touched={formProps.touched}
			errors={formProps.errors}
			required
			testId={FieldAutomationIds.employeeTypeRadio}

		/>
    );
}